module.exports = __webpack_public_path__ + "static/media/dk4055.f99017c2.png";